import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useAppQuery } from '../use-app-query.hook';

export const useCalcScenarioInvestment = ({
  scenarioId,
  investmentId,
}: {
  investmentId: string;
  scenarioId: string;
}) => {
  const queryClient = useQueryClient();

  const { data, isLoading } = useAppQuery<{ issuedShares: number; ownership: number }>({
    queryKey: [QueryKey.CALC_SCENARIO_INVESTMENT, scenarioId, investmentId],
    queryFn: () =>
      ApiService.get({
        endpoint: BackendRoute.SCENARIOS,
        routePath: [scenarioId, 'investments', investmentId, 'calc'],
      }),
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    enabled: !!scenarioId && !!investmentId,
  });

  const invalidateQuery = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: [QueryKey.CALC_SCENARIO_INVESTMENT] });
  }, [queryClient]);

  return {
    invalidateQuery,
    data,
    isLoading,
  };
};
